<template>
  <div class="md-card">
    <div class="md-card-header">
      <div class="card-icon">
        <i class="fa fa-globe"></i>
      </div>
      <h4 class="title">{{ getTitle() }}</h4>
    </div>
    <div class="md-card-content">
      <div class="md-layout-item">
        <admin-form></admin-form>
      </div>
    </div>
  </div>
</template>
<script>
import ManagementAdminPage from "./ManageAdminPage.vue";
export default {
  inject: ["manageAdmin"],
  components: {
    "admin-form": ManagementAdminPage,
  },
  methods: {
    getTitle() {
      if (this.manageAdmin.page == "Approval") return "Admin Approval";
      else if (this.manageAdmin.id) return "Edit Admin";
      else return "New Admin";
    },
  },
};
</script>
